import { useState } from 'react';
import './blog.css';
import { Link } from 'react-router-dom';

const Blog = () => {
  const [blogs] = useState([
    {
      image: 'assets/images/blogs/blogImg5.jpg',
      title: 'WHY IS SOFTWARE TESTING IMPORTANT?',
      description: 'Discover why software testing is crucial to ensure quality, catch bugs early, and deliver reliable, user-friendly applications that perform flawlessly',
      link: 'software-testing-importance',
    },
    {
      image: 'assets/images/blogs/Web-Development-Framework.jpg',
      title: 'TOP WEB DEVELOPMENT FRAMEWORKS TO USE IN 2025',
      description: 'Learn about the technologies shaping the future of mobile apps for iOS and Android.',
      link: 'web-development',
    },
    {
      image: 'assets/images/blogs/blogImg7.webp',
      title: 'Why Use Redux in 2025: A Must-Know State Management Tool',
      description: 'Explore how Redux continues to be a powerful state management solution for scalable React applications in 2025.',
      link: 'redux',
    },
    {
      image: 'assets/images/blogs/hybrid-native.jpg',
      title: 'NATIVE VS HYBRID APPLICATIONS',
      description: 'Discover the importance of quality assurance and how it prevents costly mistakes.',
      link: 'native-hybrid',
    },
    {
      image: 'assets/images/blogs/blogImg6.jpg',
      title: 'TOP 5 SKILLS EVERY QA ANALYST SHOULD MASTER IN 2025',
      description: 'Discover the essential skills QA analysts need in 2025 to stay competitive, including automation, test planning, and agile practices.',
      link: 'qa-analyst',
    },
    {
      image: 'assets/images/blogs/QA-Outsourcing.jpg',
      title: 'WHY IS OUTSOURCING QA BENEFICIAL?',
      description: 'Boost your website traffic with these proven SEO strategies and tips.',
      link: 'outsourcing-qa',
    },
    {
      image: '/assets/images/blogs/qa-analyst.png',
      title: 'IMPORTANCE OF A QA ANALYST',
      description: 'Explore the latest trends in website development and how they impact businesses in 2025.',
      link: 'qa-importance',
    },
    {
      image: 'assets/images/blogs/blogImg8.jpg',
      title: 'Best Web Development Languages to Learn in 2025',
      description: 'Stay ahead in tech by learning the top programming languages for web development in 2025, including JavaScript, Python, and more.',
      link: 'development-language',
    }

  ]);

  return (
    <div className="blog">
      {/* Hero Section */}
      <section className="blog-hero-section">
        <div className="blog-hero-text">
          <h2>
            Welcome to Our Blog
            <br /> Insights and <span style={{ color: 'yellow' }}>Ideas...</span>
          </h2>
          <p>Stay updated with the latest trends, tips, and stories from the tech world.</p>
        </div>
      </section>

      {/* Blog Cards Section */}
      <div className="blogs-container">
        {blogs.map((blog) => (
          <Link
            to={`/blog/${blog.link}`}
            key={blog.id}
            style={{ textDecoration: 'none', color: 'inherit' }}
           className="blog-card">
              <div className="blog-image-container">
                <img src={blog.image} alt={blog.title} className="blog-image" />
              </div>
              <div className="blog-content">
                <h3>{blog.title}</h3>
                <p>{blog.description}</p>
                <span className="read-more">Read More...</span>
              </div>
            
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;
